/**
 * LoadingSpinner – mali loader sa porukom
 *
 * Koristi se kao fallback za React.lazy() (Suspense) i gde god treba kompaktan spinner.
 */
import React from 'react';
import './LoadingSpinner.css';

// ---------- Komponenta ----------
const LoadingSpinner = ({ message = 'Учитавање...' }) => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner">
        <div className="spinner"></div>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
